const MAPLIBRE_WORLD_CIRCUMFERENCE_AT_ZOOM_ZERO = 512;

interface ResponsiveGlobeZoomOptions {
    configuredZoom: number;
    height: number;
    minZoom: number;
    padding: number;
    width: number;
}

const calculateResponsiveGlobeZoom = ({
    configuredZoom,
    height,
    minZoom,
    padding,
    width,
}: ResponsiveGlobeZoomOptions): number => {
    const availableDiameter = Math.max(1, Math.min(width, height) - padding * 2);
    /*
     * MapLibre's world size represents the projected circumference, while the
     * visible globe is a disc. Convert the desired disc diameter back to that
     * circumference before deriving the zoom level.
     */
    const fittedZoom = Math.log2(
        (availableDiameter * Math.PI) / MAPLIBRE_WORLD_CIRCUMFERENCE_AT_ZOOM_ZERO,
    );

    return Math.max(minZoom, Math.min(configuredZoom, fittedZoom));
};

export { calculateResponsiveGlobeZoom };
